// extracted by mini-css-extract-plugin
export default {"row":"UserModal_row__PzufJ","column":"UserModal_column__6E2sE"};